import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./DeliveryDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import DeliveryScreen from "../../../screens/Delivery/DeliveryScreen";
import StockTransferScreen from "../../../screens/Delivery/StockTransferScreen";
import DeliveryDetailsScreen from "../../../screens/Delivery/DeliveryDetailsScreen";
import ReserveStockReportScreen from "../../../screens/Reports/ReserveStockReportScreens/ReserveStockReportScreen";
import ReserveStockDetailsScreen from "../../../screens/Reports/ReserveStockReportScreens/ReserveStockDetailsScreen";
import { useTranslation } from "../../../utils/useTranslation";
import DeliveryAppointmentsScreen from "../../../screens/Delivery/calendar/DeliveryAppointmentsScreen";

const Drawer = createDrawerNavigator();

export default function DeliveryDrawerNavigator() {
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={drawerItemsMain} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: t("delivery"),
          title: t("delivery"),
        }}
        name="DeliveryReport"
        component={DeliveryScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("appointment"),
          title: t("appointment"),
        }}
        name="DeliveryAppointmentScreen"
        component={DeliveryAppointmentsScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("delivery"),
          title: t("delivery"),
        }}
        name="DeliveryDetailsScreen"
        component={DeliveryDetailsScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("Reserve Stock"),
          title: t("Reserve Stock"),
        }}
        name="ReserveStock"
        component={ReserveStockReportScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("Reserve Stock Details"),
          title: t("Reserve Stock Details"),
        }}
        name="ReserveStockDetailsScreen"
        component={ReserveStockDetailsScreen}
      />
      <Drawer.Screen
        options={{
          drawerLabel: t("stockTransfer"),
          title: t("stockTransfer"),
        }}
        name="StockTransferReport"
        component={StockTransferScreen}
      />
    </Drawer.Navigator>
  );
}
